// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605260011/js/" + chunkId + "." + {"44":"671644cb","225":"175522c0","481":"5c1d87d5","486":"980fa354","770":"0d05cba3"}[chunkId] + ".0.06667330158434759.chunk.js";
};